var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 102,
    viewBox: "0 0 404 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.637 11.4517H400.725L403.79 0H40.731C32.4938 0 25.1067 7.33004 22.1255 18.4523L0 101.071H10.971L30.0275 29.9039C33.0087 18.7759 40.3998 11.4517 48.637 11.4517Z",
    fill: "#F58220"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9277 14.6084H392.699C396.133 14.6084 398.662 17.7641 397.983 21.0742L397.907 21.3945L381.607 82.2578C378.661 93.2493 371.433 100.259 363.59 100.259H21.8184C18.3846 100.259 15.8563 97.1039 16.5352 93.7939L16.6104 93.4727L32.9102 32.6104C35.8563 21.6189 43.0848 14.6084 50.9277 14.6084Z",
    fill: "url(#paint0_linear_16246_111022)",
    stroke: "url(#paint1_linear_16246_111022)",
    strokeWidth: 1.21768
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16246_111022",
    x1: -95.0532,
    y1: 57.4339,
    x2: 406.05,
    y2: 57.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.370192,
    stopColor: "#001B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16246_111022",
    x1: 14,
    y1: 57.4339,
    x2: 400.518,
    y2: 57.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4515",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07E27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderBg);
export default __webpack_public_path__ + "static/media/tableHeaderBg.f20969afd3656e6f31de7d4049f78c5b.svg";
export { ForwardRef as ReactComponent };